export default {"src":"/_next/static/media/beef.941fdb45.svg","height":17,"width":21,"blurWidth":0,"blurHeight":0};